import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import './style.css'
import { Provider } from 'react-redux'
import Store from './Redux/Store';
import { BrowserRouter, Route } from 'react-router-dom';
import Login from './Login/Login';

ReactDOM.render(
    <Provider store={Store}>
        <BrowserRouter>
            <div>
                <Route path="/" component={App} />
                <Route exact path="/login" component={Login} />
            </div>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
